<!-- left hand table -->
<div style="padding:0; padding-left: 8px; font-weight: bold; color:red;">
    <span>WARNING: Please exercise extreme caution when using this module. Deduplicated records cannot be reversed.</span>
</div>
<table style="width: 100%; height: 580px; padding: 5px;">
    <tr>
        <td style="width: 20%;max-width: 250px;">
            <div style="height: 100%;width: 100%;max-width: 250px;">
                <div style="color:blue;margin-bottom: 10px;margin-left: 3px;">
                    <label matTooltipPosition="below"
                        matTooltip="This is the member you selected from the case list">Member:</label></div>
                 <div #tb1 class="table-container mat-elevation-z1" style="height: 500px;outline:none;" tabindex="-1">
			            <table mat-table [dataSource]="dataSource1" style="width:100%;">
			                <ng-container matColumnDef="label" >
			                    <th mat-header-cell *matHeaderCellDef
			                         style="padding-left: 4px;background: white;">Details
			                    </th>
			                    <td mat-cell style="padding-left:4px; font-size: 9pt;width: 100% !important;max-width: 250px;"
			                        *matCellDef="let element">{{element.label}}</td>
			                </ng-container>
			              
			                <tr mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
			                <tr mat-row
			                    *matRowDef="let row; columns: displayedColumns1; let tableRowIdx = index;"
			                    [ngClass]="{'row-selected': tableRowIdx == Idx1}">
			                </tr>
			            </table>
			       </div>
			  </div>
        </td>
        <!-- DIRECTION BUTTONS -->
        <td style="width: 10%; vertical-align: middle;">
            <table style="height: 100%;width: 100%;">
                <tr>
                	<td style="text-align: center;">
                		<button mat-button style="vertical-align: middle;background-color:silver;font-weight:
                                bold;font-size: larger;" (click)="handleSecondOption()"
                                [disabled]="disableMoveRightBtn"
                                matTooltipPosition="above"
                                matTooltip="Replace the selected similar member(s) with the member record to the left">
		                    >
		                </button> <br>
		                <button mat-button
                                style="vertical-align: middle;margin-top: 20px;background-color:silver;font-weight:
                                bold;font-size: larger;"
                                (click)="handleFirstOption()"
                                [disabled]="disableMoveLeftBtn"
                                matTooltipPosition="right"
                                matTooltip="Replace the member on the left with a selected similar member">
		                    <
		                </button>
		                <br>
		                <button mat-button
                                style="vertical-align: middle;margin-top: 20px;background-color:silver;font-weight:
                                bold;font-size: larger;"
                                (click)="handleThirdOption()"
                                [disabled]="disableBypassBtn"
                                matTooltipPosition="below"
                                matTooltip="Mark these as distinctly different records">
		                  &ne;
		                </button>
                	</td>
                </tr>
            </table>
        </td>

        <!--Right hand table -->
        <td style="width: 50%">
            <div style="height: 100%;width: 100%;">
                 <div style="color:blue;margin-bottom: 10px;">
                     <label mattooltipPosition="above"
                        matTooltip="The system found these members that have the same/similar information">Similar
                     members:</label></div>

                    <div #tb2 class="table-container mat-elevation-z1"
                      style="height: 500px;outline:none;"
			              tabindex="-1">
			            <table mat-table [dataSource]="dataSource2" cdkDropList
						  style="width:100%">
                        <ng-container matColumnDef="select">
									    <th mat-header-cell *matHeaderCellDef class="table-header-style-override" style="width: 50px;background: white;">
									    </th>
									    <td mat-cell *matCellDef="let element;let tableRowIdx = index;" style="width: 50px !important;">
									        <mat-checkbox (click)="$event.stopPropagation();"
                                                          (change)="doCheckUnCheck($event)"
                                                          [disabled]="false" [(ngModel)]="element.isSelected">
									        </mat-checkbox>
									    </td>
									 </ng-container>
									 <ng-container matColumnDef="id">
									    <th mat-header-cell class="mat-table-header-style mat-table-header-override"
											*matHeaderCellDef> Id
										</th>
									    <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
											class="table-row-class">
									    <span>{{element.id}}</span>
									    </td>
									  </ng-container>
					                   <ng-container matColumnDef="firstName">
									    <th mat-header-cell class="mat-table-header-style mat-table-header-override"
											*matHeaderCellDef> First
										</th>
									    <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
											class="table-row-class">
									    <span>{{element.firstName}}</span>
									    </td>
									  </ng-container>
                                    <ng-container matColumnDef="middleName">
                                        <th mat-header-cell class="mat-table-header-style mat-table-header-override"
                                            *matHeaderCellDef> Middle
                                        </th>
                                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                                            class="table-row-class">
                                            <span>{{element.middleName}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="lastName">
									  <th mat-header-cell *matHeaderCellDef  class="mat-table-header-style mat-table-header-override"> Last</th>
									  <td mat-cell *matCellDef="let element"  style="padding-left: 1px" class="table-row-class">
									    <span>{{element.lastName}}</span>
									  </td>
									</ng-container>
									
								<ng-container matColumnDef="dateOfBirth">
								  <th mat-header-cell *matHeaderCellDef
									  class="mat-table-header-style mat-table-header-override"> DOB </th>
								  <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
								    <span>{{lblShowDate(element.dateOfBirth)}}</span>
								  </td>
								</ng-container>

                                <ng-container matColumnDef="gender">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="mat-table-header-style mat-table-header-override"> Gender </th>
                                    <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                                        <span>{{element.gender}}</span>
                                    </td>
                                </ng-container>
                                 <ng-container matColumnDef="dateAdded">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="mat-table-header-style mat-table-header-override"> Date Added </th>
                                    <td mat-cell *matCellDef="let element" style="padding-left: 1px" class="table-row-class">
                                        <span>{{element.dateAdded | date}}</span>
                                    </td>
                                </ng-container>
                                 <ng-container matColumnDef="memberComments">
									    <th mat-header-cell class="mat-table-header-style mat-table-header-override"
											*matHeaderCellDef> Comments
										</th>
									    <td mat-cell *matCellDef="let element" style="padding-left: 5px;max-width: 140px;"
											class="table-row-class">
									    <span>{{element.memberComments}}</span>
									    </td>
									  </ng-container>

							  <tr mat-header-row *matHeaderRowDef="displayedColumns2; sticky: true"></tr>
			                  <tr mat-row
			                        *matRowDef="let row; columns: displayedColumns2; let tableRowIdx = index;"
			                        [ngClass]="{'row-selected': tableRowIdx == Idx}">
				                  </tr>
			            </table>
			        </div>
            </div>
        </td>
    </tr>
</table>

<!----------------------->
<!-- ERROR LINE --------->
<!----------------------->
<div class="error-line" [hidden]='!strErr.length'
     style="text-align:left">{{ strErr }}
</div>
<!----------------------->
<!-- SAVE STRIP        -->
<!----------------------->
<div class="save-close-strip" style="bottom: 55px;">

    <button class="command-button" 
            (click)="cancelSubmitRecord()"
            matTooltipPosition="above"
            matTooltip="Close this dialog" mat-button>
        <mat-icon>highlight_off</mat-icon>
        Close
    </button>
</div>
